// extracted by mini-css-extract-plugin
export default {"legalNotice":"_3EXrD6bWDCgp6uDlbvNwsJ"};